import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import tqp from "../../../Artifacts/SalesSucessCenter/tqp.png";
import rupeeOrange from "../../../Artifacts/SalesSucessCenter/rupeeOrange.png";
import rupeeBlue from "../../../Artifacts/SalesSucessCenter/rupeeBlue.png";
import offtake from "../../../Artifacts/SalesSucessCenter/offtake.png";
import retail from "../../../Artifacts/SalesSucessCenter/retail.png";
import { axInst } from "../../../Components/Login/Service";
import { Loader } from "rsuite";
import WaterMark from "../../../Components/WaterMark/WaterMark.jsx";
import { CylinderProgress } from "../../../Components/KPI/CylinderProgressBarCustom";

const accordionItems = [
  {
    status: "retail",
    label: "Bottom 5 dealerships in Retail",
    bg: "bg-[#beddff]",
    icons: retail,
  },
  {
    status: "tqp",
    label: "Bottom 5 dealerships in TQP",
    bg: "bg-[#FFF5DC]",
    icons: tqp,
  },
  {
    status: "offtake",
    label: "Bottom 5 dealerships in Offtake",
    bg: "bg-[#E3F0FF]",
    icons: offtake,
  },
  {
    status: "cpr",
    label: "Top 5 dealerships by CPR",
    bg: "bg-[#E8FCFF]",
    icons: rupeeBlue,
  },
  {
    status: "cpl",
    label: "Top 5 dealerships by CPL",
    bg: "bg-[#FFECDD]",
    icons: rupeeOrange,
  },
];

const DealerAnalyticsApi = async (body) => {
  try {
    const res = await axInst.post(
      "dealer-sales-success-centre/actionable_insights",
      body
    );
    return res.data;
  } catch (error) {
    console.error("Error fetching service adoption data:", error);
    throw error;
  }
};

const Analytics = () => {
  const { data: filterData } = useSelector((e) => e.filtersSalesSuccessCenter);
  const [activeAccordion, setActiveAccordion] = useState(null);

  const {
    data: DealerAnalyticsData,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["DealerAnalytics", filterData, activeAccordion],
    queryFn: () =>
      DealerAnalyticsApi({
        ...filterData,
        insights_status: activeAccordion,
      }),
    enabled: !!activeAccordion,
    cacheTime: 0,
    staleTime: 0,
  });

  const toggleAccordion = (status) => {
    setActiveAccordion((prev) => (prev === status ? null : status));
  };

  const toTitleCase = (str) =>
    str
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");

  const isThreeColumn =
    activeAccordion === "retail" ||
    activeAccordion === "tqp" ||
    activeAccordion === "offtake";

  return (
    <div className="bg-white rounded-xl shadow relative h-full">
      <WaterMark />
      <div className="bg-[#2A5775] text-center text-white py-2 font-semibold rounded-t-xl">
        Dealer Analytics
      </div>

      <div className="divide-y">
        {accordionItems.map(({ status, label, bg, icons }) => (
          <div key={status} className="border-b">
            <button
              onClick={() => toggleAccordion(status)}
              className={`w-full flex items-center hover:bg-[#B7D9FF] ${bg}`}
            >
              <div className="flex w-full justify-between items-center px-2 py-[7px] ">
                <img src={icons} alt={label} className="w-[32px] h-[32px]" />
                <span className="text-sm px-1">{label}</span>
                <svg
                  className={`w-4 h-4 transform transition-transform ${
                    activeAccordion === status ? "rotate-180" : ""
                  }`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </div>
            </button>

            {activeAccordion === status && (
              <div className="absolute left-0 right-0 z-10 py-2 bg-gray-50 text-center shadow-lg rounded-b-xl max-h-52 overflow-y-auto scrollbar-none">
                {isFetching ? (
                  <div className="flex justify-center items-center">
                    <Loader />
                  </div>
                ) : isError ||
                  !DealerAnalyticsData ||
                  DealerAnalyticsData.length === 0 ? (
                  <p>Data not available</p>
                ) : (
                  <>
                    {isThreeColumn ? (
                      <div className="px-2">
                        {DealerAnalyticsData.map((item, index) => (
                          <div key={index}>
                            <CylinderProgress
                              label={toTitleCase(item.dealer_name)}
                              value={item.success + "%"}
                              target={item.target}
                              actualTitle="Achievement"
                              targetTitle="Target"
                              per=" < 35"
                            />
                          </div>
                        ))}
                      </div>
                    ) : (
                      <ul className="list-disc list-inside text-gray-700 space-y-2">
                        {DealerAnalyticsData.map((item, index) => (
                          <li
                            key={index}
                            className="text-xs flex justify-between gap-1 border-b border-b-gray-300 px-2 last:border-b-0"
                          >
                            <span>{toTitleCase(item.dealer_name)}</span>
                            <span>{item.value}</span>
                          </li>
                        ))}
                      </ul>
                    )}
                  </>
                )}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Analytics;
